<template>
  <div class="sword-warning-message-wuk">
    <sword-icon-wuk name="warning" />
    <span class="t4 fc-ctx-1">
      {{ text }}
    </span>
  </div>
</template>

<script>
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue';

export default {
  name: 'WarningMessageWuk',
  components: { SwordIconWuk },
  props: {
    text: {
      type: String,
      default: null
    }
  },
};
</script>

<style lang="scss" scoped>
  .sword-warning-message-wuk {
    @include input-footer-wrapper-wuk;
    .sword-icon {
      color: $hard-red;
      width: 1.2rem;
      height: .9rem;
    }
  }
</style>
